import clsx from 'clsx';
import camelCase from 'just-camel-case';
import capitalize from 'just-capitalize';

import type { FagmoblerPublicOmniumProduct } from '@fagmobler/types';

import { translateProperty, resolveProperties } from './utils';
import { ProductPageProps } from '../..';

type propertyKey = FagmoblerPublicOmniumProduct['properties'][0]['key'];

export type KeyPropertiesProps = {
  product?: FagmoblerPublicOmniumProduct;
  allowedProperties?: propertyKey[];
  disallowedProperties?: propertyKey[];
  generatedProductData: ProductPageProps['generatedProductData'];
};

type Property =
  | {
      text: string;
      postfix?: undefined;
    }
  | {
      text: string;
      postfix: string;
    };

export function KeyProperties({
  product,
  allowedProperties = [],
  disallowedProperties = [
    'serie',
    'posterName',
    'posterDescription',
    'ean1',
    'ean2',
    '3dlink',
    'hms',
    'posterSalesText',
    'salesInfo',
    // 'bedsize',
    'space',
  ],
  generatedProductData,
}: KeyPropertiesProps) {
  if (!product) return null;

  const properties = resolveProperties(
    product,
    allowedProperties,
    disallowedProperties
  );

  const getValue = (
    key: string,
    value: string | undefined,
    property: Property
  ) => {
    if (key === 'origin') {
      return generatedProductData?.originCountry || value;
    }

    if (!value) return 'Ukjent';

    return `${value} ${property.postfix ?? ''}`;
  };

  return (
    <table className={clsx('border-collapse', 'w-full')}>
      <tbody className="print:columns-2 print:gap-10 print:break-before-avoid-page print:block print:w-full">
        {properties.map(({ key, value }, index) => {
          const property: Property = translateProperty(camelCase(key));

          return (
            <tr
              key={key}
              className={clsx({
                'bg-neutral-30 print:bg-[transparent]': index % 2 === 1,
              })}
            >
              <th
                className={clsx(
                  'text-left',
                  'hd-base',
                  'p-4 pr-5',
                  'print:p-1',
                  'print:pl-0',
                  'print:hd-xs',
                  'print:w-1/3'
                )}
              >
                {capitalize(property.text)}
              </th>
              <td
                className={clsx(
                  'p-4 body-base',
                  'print:p-1',
                  'print:body-xs',
                  'print:w-2/3'
                )}
              >
                {getValue(key, value, property)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default KeyProperties;
